type Listener = (busy: boolean) => void;
type BootListener = () => void;

const listeners = new Set<Listener>();
const bootListeners = new Set<BootListener>();
let pending = 0;
let appBootReady = false;

function emit() {
  const busy = pending > 0;
  for (const fn of listeners) fn(busy);
}

export function startPageProgress() {
  pending += 1;
  emit();
}

export function finishPageProgress() {
  pending = 0;
  emit();
}

export function subscribePageProgress(fn: Listener) {
  listeners.add(fn);
  fn(pending > 0);
  return () => {
    listeners.delete(fn);
  };
}

/** Full-page boot loader (F5 / hard refresh) — hide once shell + auth are ready. */
export function markAppBootReady() {
  if (appBootReady) return;
  appBootReady = true;
  for (const fn of bootListeners) fn();
}

export function subscribeAppBoot(fn: BootListener) {
  bootListeners.add(fn);
  if (appBootReady) fn();
  return () => {
    bootListeners.delete(fn);
  };
}
